import { useParams } from 'react-router-dom';

export const useLanguage = (): string => {
    const { language = 'nl' } = useParams();
    return language;
};
